import type { TBlockedUser, TError } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';
import { getBlockedUsersQueryKey, getUserBlockedUsersQueryKey, USER_BLOCKS_ENTITY } from './entity';

/** The current user's blocked users (account settings → Security and Privacy). */
export const useGetBlockedUsersQuery = () => {
  return useQuery<TBlockedUser[], TError>({
    queryKey: getBlockedUsersQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TBlockedUser[]>(`/${USER_BLOCKS_ENTITY}`);
      return res.data;
    },
  });
};

/** Admin: a given user's blocked users (dashboard user details). */
export const useGetUserBlockedUsersQuery = (authUserId?: string) => {
  return useQuery<TBlockedUser[], TError>({
    queryKey: getUserBlockedUsersQueryKey(authUserId ?? ''),
    queryFn: async () => {
      const res = await axios.get<TBlockedUser[]>(`/${USER_BLOCKS_ENTITY}/admin/${authUserId}`);
      return res.data;
    },
    enabled: !!authUserId,
  });
};
